$(window).on('load', function() {
  $('#main-cart-footer').insertAfter('.cart__contents-wrap');
});

$(window).on('load', function() {
  ele = $('.tax-note');
  if ($.trim(ele.text()) == '') {
    ele.addClass('empty');
  }
});

// あとで買うボタンクリック後カートから削除
$(document).ready(function() {
  $(".swym-button").on("click", function() {
    delCart($(this).data('product-handle')); // EC インテリジェンスタグ要関数
    let removeUrl = $(this).attr("data-remove-item-url");
    console.log(removeUrl);
    window.location.href = removeUrl;
  });
});

//  お買い物を続けるボタンのURL更新
$(window).on('load', function() {
  const updateUrl = () => {

    let backButton = $(".back-product");
    let foundProductUrl = "/";
    let currentDomain = window.location.origin;

    for (let i = history.length - 1; i >= 0; i--) {
      try {
        let prevUrl = document.referrer;
        if (prevUrl.includes(currentDomain + "/products/")) {
          foundProductUrl = prevUrl;
          break;
        }
      } catch (e) {
        console.error("Error accessing history:", e);
      }
    }

    backButton.attr("href", foundProductUrl);
  }
  $(window).on('change', function() {
    if (event.target.matches('.quantity__button, .quantity__input')) {
      setTimeout(updateUrl, 2000);
    }
  });
  $(window).on('click', function() {
    if (event.target.matches('.delete-btn')) {
      setTimeout(updateUrl, 1000);
    }
  });
  updateUrl();
});
